import React from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../../services/i18n';
import { convertFooterDataToAdaptedObject } from '../../utils/s3Utils';
import CompanyAdress from './components/CompanyAdress';
import Divider from './components/Divider';
import FooterMenu from './components/FooterMenu';
import FooterTop from './components/FooterTop';
import classes from './style.module.scss';
import useFooter from '../../hooks/useFooter';

export default function Footer() {
  const { i18n } = useTranslation();
  const isLanguageTr = i18n.language === LANGUAGES.TR;
  const { footerData } = useFooter();

  if (!footerData) {
    return null;
  }

  const {
    socialMediaAccounts,
    footerMenus,
    bitexenDescription,
    externalLogos,
    footerText,
    baseUrl
  } = convertFooterDataToAdaptedObject(footerData, isLanguageTr);

  return (
    <>
      <FooterTop socialMediaAccounts={socialMediaAccounts} />
      <div className={classes.container}>
        <div className={classes.innerContainer}>
          <Divider />
          <div className={classes.middlePane}>
            <FooterMenu footerMenus={footerMenus} baseUrl={baseUrl} />
            <CompanyAdress addressDatas={bitexenDescription} externalLogos={externalLogos} />
          </div>
          <Divider />
          <span className={classes.copyRight}>{footerText}</span>
        </div>
      </div>
    </>
  );
}
